import { render } from "./p-select.vue?vue&type=template&id=72a48b01&scoped=true"
import script from "./p-select.vue?vue&type=script&lang=js"
export * from "./p-select.vue?vue&type=script&lang=js"

import "./p-select.vue?vue&type=style&index=0&id=72a48b01&scoped=true&lang=scss"
import "./p-select.vue?vue&type=style&index=1&id=72a48b01&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a48b01"]])

export default __exports__